export default "__VITE_ASSET__a8c30539__"